import {useEffect} from "react";
import database from "../database/database";
import isNull from "../mixin/isNull";
import Home from "./public/Home";
import {useNavigate} from "react-router";
import route from "../enum/route";
import useIdpRepository from "../repository/auth/useIdpRepository";

export default function () {
    const navigate = useNavigate();
    const idpRepository = useIdpRepository();

    useEffect(() => {
        solveUser();
    }, []);

    const solveUser = async () => {
        const userinfo = await idpRepository.userinfo();

        if (isNull(userinfo)) {
            console.info("User not authenticated");
            return;
        }

        database.write(database.TABLE_AUTHENTICATION, 'roles', userinfo.roles);
        database.write(database.TABLE_AUTHENTICATION, 'username', userinfo.preferred_username);
        database.write(database.TABLE_AUTHENTICATION, 'id', userinfo.attributes.external_id);
        database.write(database.TABLE_AUTHENTICATION, "attributes", userinfo.attributes);

        console.info("User authenticated, redirect to " + route.ENTREPRENEUR_INTERVENTIONS);
        navigate(route.ENTREPRENEUR_INTERVENTIONS);
    }


    return <Home/>;
}